import React, { useContext } from "react";

// Global state
import { StateContext, StateDispatchContext } from "../../AppStateContext";

// Material UI stuff
import IconButton from "@material-ui/core/IconButton";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";

const CloseDrawerButton = ({ classes }) => {
  // Consuming state
  const state = useContext(StateContext);
  const setState = useContext(StateDispatchContext);

  // closing drawer
  const handleDrawerClose = () => {
    setState({ ...state, isSidebarOpen: false });
  };

  return (
    <div className={classes.toolbar}>
      <IconButton onClick={handleDrawerClose}>
        <ChevronLeftIcon
          style={{ color: state.theme === "light" ? "#ffffff" : "#fa0171" }}
        />
      </IconButton>
    </div>
  );
};

export default CloseDrawerButton;
